/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
import { HTMLAttributeAnchorTarget, ReactElement } from 'react';
import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import Badge, { BadgeProps } from '@mui/material/Badge';

import { OverridableComponent } from '@mui/material/OverridableComponent';

import { SvgIconTypeMap } from '@mui/material';
import Tooltip, { TooltipProps } from './Tooltip';

export interface IconButtonProps extends Omit<MuiIconButtonProps, 'title' | 'sx'> {
  href?: string;
  target?: HTMLAttributeAnchorTarget;
  icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> | string;
  title?: TooltipProps['title'];
  badgeContent?: BadgeProps['badgeContent'];
  iconProps?: Partial<SvgIconTypeMap<{}, 'svg'>>;
  tooltipProps?: Partial<TooltipProps>;
  badgeProps?: Partial<BadgeProps>;
  sx?: BadgeProps['sx'];
}

export default function IconButton({
  icon: Icon,
  title = '',
  badgeContent = 0,
  size = 'small',
  iconProps = {},
  tooltipProps = {},
  badgeProps = {},
  sx = {},
  children,
  ...iconButtonProps
}: IconButtonProps): ReactElement {
  return (
    <Badge
      color="primary"
      badgeContent={badgeContent}
      overlap="circular"
      {...badgeProps}
      // @ts-ignore
      sx={{ ...sx, ...(badgeProps.sx || {}) }}
    >
      <Tooltip title={title} {...tooltipProps}>
        <MuiIconButton
          size={size}
          {...iconButtonProps}
          onMouseOver={(e: any) => {
            e.stopPropagation();
          }}
          onMouseMove={(e: any) => {
            e.stopPropagation();
          }}
          // onMouseOverCapture={(e) => e.stopPropagation()}
          // onMouseMoveCapture={(e) => e.stopPropagation()}
          onMouseEnter={(e: any) => {
            e.stopPropagation();
          }}
        >
          {Icon && <Icon fontSize={size} {...iconProps} />}
          {children}
        </MuiIconButton>
      </Tooltip>
    </Badge>
  );
}
